import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'
import { CSRF_TOKEN_NAME } from '@/constants'
import type { DocumentPageThemeIn, DocumentPageTheme } from './types'

export const createDocumentPageTheme = async (values: DocumentPageThemeIn) => {
  await getCsrf()
  const resp = await client.POST('/api/v1/projects/document_page_themes', {
    headers: {
      'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
    },
    body: values,
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to create document page theme'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const listDocumentPageThemes = async () => {
  const resp = await client.GET('/api/v1/projects/document_page_themes')
  if (resp.error || !resp.response.ok) {
    const message = 'Failed to list document page themes'
    throw new CustomError(resp, message)
  }

  return resp.data as DocumentPageTheme[]
}

export const getDocumentPageTheme = async (documentPageThemeId: string) => {
  const resp = await client.GET(
    '/api/v1/projects/document_page_themes/{document_page_theme_id}',
    {
      params: {
        path: {
          document_page_theme_id: documentPageThemeId,
        },
      },
    },
  )
  if (resp.error || !resp.response.ok) {
    const message = 'Failed to get document page theme'
    throw new CustomError(resp, message)
  }

  return resp.data as DocumentPageTheme
}

export const updateDocumentPageTheme = async (
  documentPageThemeId: string,
  values: DocumentPageThemeIn,
) => {
  await getCsrf()
  const resp = await client.PUT(
    '/api/v1/projects/document_page_themes/{document_page_theme_id}',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_page_theme_id: documentPageThemeId,
        },
      },
      body: values,
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to update document page theme'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const deleteDocumentPageTheme = async (documentPageThemeId: string) => {
  await getCsrf()
  const resp = await client.DELETE(
    '/api/v1/projects/document_page_themes/{document_page_theme_id}',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_page_theme_id: documentPageThemeId,
        },
      },
      parseAs: 'text',
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to delete document page theme'
    throw new CustomError(resp, message)
  }

  return true
}
